<template>
  <div>
    <div style="padding: 1rem 1.5rem;overflow-y: auto;" :style="{height:form.shenpiflag!=1&&form.editflag!=1?'17rem':'15rem'}">
      <a-row>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">派息日期</div>
            <!-- <a-input v-model="form.dividends_date" :disabled="true" style="color: #000;"/> -->
            <a-date-picker :disabled-date="disabledDate" v-model="form.dividends_date" class="inputClass" style="width: 100%" @change='timehand' :disabled="(form.editflag !=1)" :placeholder="'請選擇派息時間'" />
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">股票市場</div>
            <a-select  ref="select" v-model="form.market" @change="marketOn(form.market)" :disabled="(form.editflag !=1)" placeholder="請選擇股票市場" style="width: 100%;">
              <a-select-option value="港股">港股</a-select-option>
              <a-select-option value="美股">美股</a-select-option>
            </a-select>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin-top:0.5rem">
        <a-col :span="11">
          <div style="display:flex;align-items: center;position: relative;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">股票代碼</div>
            <!-- <a-input v-model="form.stockcode" :disabled="(form.editflag !=1)" style="color: #000;" placeholder="請輸入股票代碼"  onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'');" /> -->
            <a-auto-complete :data-source="tabData1" :disabled="(form.editflag !=1)" @search="handleSearch" :style="'width: 100%'" @change="stockcodeOn(form.stockcode)" placeholder="請輸入股票代碼" @focus='focus' v-model="form.stockcode" ></a-auto-complete>
            <span style="position:absolute;right: 4%;" v-if="form.stockcode && form.market == '港股'">.HK</span>
            <span style="position:absolute;right: 4%;" v-if="form.stockcode && form.market == '美股'">.US</span>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">股票名稱</div>
            <a-input  v-model="form.stockname" :disabled="true" style="color: #000;" placeholder="請輸入股票名稱"/>
          </div>
        </a-col>
      </a-row>
      <a-row style="margin:0.5rem 0">
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">派息幣種</div>
            <a-select  ref="select" v-model="form.dividends_ccytype" :disabled="(form.editflag !=1)" placeholder="請選擇派息幣種" style="width: 100%;">
              <a-select-option value="HKD">HKD</a-select-option>
              <a-select-option value="USD">USD</a-select-option>
            </a-select>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
        <a-col :span="11">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;margin-right: 0.5rem;">派息金額</div>
            <a-input  v-model="form.dividends_price" placeholder="請輸入派息金額" :disabled="(form.editflag !=1)" style="color: #000;" />
          </div>
        </a-col>
      </a-row>
      <div style="margin-top:1rem">
        <div class="recordCla" v-for="(item,ind) in auditLogList" :key="ind" :style="{ borderBottom : auditLogList.length-1 == ind?'1px solid #e5e5e5':''}">
          <div style="width:50%">{{item.handle}}</div>
          <div style="width:30%">{{item.handleuser}}</div>
          <div style="width:20%;text-align: right;">{{item.createtime}}</div>
        </div>
      </div>
    </div>
    <div style="border-top:1px solid #e5e5e5;display: flex;justify-content: end;padding: 1rem 1rem 0.6rem 0;align-items: center;" v-if="(form.shenpiflag==1)">
      <a-textarea v-model="remark" :auto-size="{ minRows: 3, maxRows: 3 }" style="margin-left: 1rem;"/>
      <div style="background:#ed4849; padding: 0.6rem 1rem;color:#fff;font-size: 0.8rem;flex-shrink: 0;margin-left: 1rem;cursor: pointer;" @click="approvalClick(2)">審批拒絕</div>
      <div style="background:#0c8b97; padding: 0.6rem 1rem;color:#fff;font-size: 0.8rem;flex-shrink: 0;margin-left: 2rem;cursor: pointer;" @click="approvalClick(1)">審批通過</div>
    </div>
    <div v-if="(form.editflag==1)">
      <div style="border-top:1px solid #e5e5e5;display: flex;justify-content: end;padding: 1rem 1rem 0.6rem 0;">
        <div style="background:#0c8b97; padding: 0.6rem 2rem;color:#fff;font-size: 0.8rem; cursor: pointer;" @click="newStockdividends()">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import App from "@/assets/app.js";
export default {
  props:['isval'],
  data(){
			return {
        tabData: [],
        tabData1: [],
        form:{
          dividends_date:'',
          market:undefined,
          stockcode:'',
          stockname:'',
          dividends_ccytype:undefined,
          dividends_price:'',
          username:this.isval.username,
          
        },
        remark:"",
        auditLogList:[]
			}
		},
		mounted() {
      if (this.isval.auditid) {
        this.getStockdividendsDataWithAuditid()
      }
		},
		methods:{
      marketOn(val){
        this.form.stockcode ='';
        this.form.stockname ='';
        if (val == '港股') {
          this.form.dividends_ccytype = 'HKD'
        }else{
          this.form.dividends_ccytype = 'USD'

        }
        
      },
      disabledDate(current) {
        return current && current < moment().subtract(1, 'days').endOf('day')
      },
      stockcodeOn(val){
        if (this.form.market == '港股') {
          this.form.stockcode=this.form.stockcode.replace(/[^\d]/g,'');
        }else{
          this.form.stockcode=this.form.stockcode.replace(/[\u4E00-\u9FA5]/g,'');
        }
        if (this.tabData.length<=0) {
          this.form.stockname ='';
        }
        for (let i = 0; i < this.tabData.length; i++) {
          let tab = this.tabData[i];
          if (tab.stockcode == val) {
            this.form.stockname = tab.stockname;
            return
          }else{
            this.form.stockname = '';
          }
          
        }
      },
      focus(){
        this.getdata()
      },
      handleSearch(val) {
				this.form.stockcode = val
				this.tabData = []
				if(val){
					this.getdata(val);
          this.stockcodeOn(val)
				}
			},
      getdata(){
				this.$ajax({
					method: 'post',
					url:  this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
            searchstr:this.form.stockcode,
            type:'stocks',
            market:this.form.market,
          }
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.tabData = res.data.result;
            this.tabData1=[];
            for (let i = 0; i < this.tabData.length; i++) {
              let tab = this.tabData[i]
              this.tabData1.push(tab.stockcode)
            }
						
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
      },
      timehand(){
        this.form.dividends_date = App.oDate.secsTime3(this.form.dividends_date._d)
      },
      getStockdividendsDataWithAuditid(){
        this.$ajax({
          method: "post",
          url: this.$api.getStockdividendsDataWithAuditid,
          data: {
            auditid:this.isval.auditid
          },
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            this.form = res.data
            this.auditLogList = res.data.auditLogList
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });
      },
      approvalClick(val){
        if (val == 1) {
          this.remark = '審批通過'
        }else{
          if (!this.remark) {
            App.oTool.warningT("請填寫審批備註");
            return
          }
        }
        this.$ajax({
          method: "post",
          url: this.$api.newStockdividendsAudit,
          data: {
            auditid:this.isval.auditid,
            handle:val,
            remark:this.remark
          },
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            this.form = res.data
            this.auditLogList = res.data.auditLogList
            this.getStockdividendsDataWithAuditid()
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });
      },
      newStockdividends(){
        console.log(this.form.dividends_date);
        if (!this.form.dividends_date) {
          App.oTool.warningT("請選擇派息時間");
          return
        }
        if (!this.form.market) {
          App.oTool.warningT("請選擇股票市場");
          return
        }
        if (!this.form.stockcode) {
          App.oTool.warningT("請輸入股票代碼");
          return
        }

        if (!this.form.stockname) {
          App.oTool.warningT("請輸入股票名稱");
          return
        }
        if (!this.form.dividends_ccytype) {
          App.oTool.warningT("請選擇派息幣種");
          return
        }
        if (!this.form.dividends_price) {
          App.oTool.warningT("請輸入派息金額");
          return
        }
        this.$ajax({
          method: "post",
          url: this.$api.newStockdividends,
          data: this.form,
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            App.oTool.successT("操作成功");
            this.getStockdividendsDataWithAuditid()
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });
      },
		
		}
}
</script>

<style>
.recordCla{
  display:flex;
  align-items: center;
  font-size: 0.8rem;
  color: #000;
  padding: 0.7rem 0;
  border-top: 1px solid #e5e5e5;
}
.inputClass .ant-input{
  color: #000;
}
.ant-select-auto-complete.ant-select .ant-input[disabled]{
  color: #000;
}
@media screen and (min-width:2200px){
  .ant-select-selection--single .ant-select-selection__rendered{
    height: 1.75rem;
    font-size: 0.8rem !important;
  }
  .ant-calendar-picker-input, .ant-input{
    font-size: 0.8rem !important;

  }
  .ant-select-auto-complete.ant-select .ant-select-selection__rendered{
    line-height: 1.75rem !important;
  }
}
</style>
